import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './Input.scss';

const Input = ({
  type = 'text',
  placeholder,
  name = '',
  onChange = () => { },
  onBlur = () => { },
  value = '',
  error = '',
}) => (
  <div className={classnames('input-container', type)}>
    <input
      className={error ? 'with-error' : 'without-error'}
      type={type}
      name={name}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      value={value}
    />
    {!!error && <div className="form-error">{error}</div>}
  </div>
);

Input.propTypes = {
  type: PropTypes.oneOf(['text', 'radio']).isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  error: PropTypes.string,
};

export default Input;
